module.exports = __webpack_public_path__ + "static/media/baptism.29674e19.jpg";